/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const Auth = {
    login        : r => require.ensure([], () => r(require('./components/login')),         'auth'),
    // ssologin        : r => require.ensure([], () => r(require('./components/ssologin')),         'auth'),
    saml        : r => require.ensure([], () => r(require('./components/saml')),         'auth'),
    register     : r => require.ensure([], () => r(require('./components/register')),      'auth'),
    verification : r => require.ensure([], () => r(require('./components/verification')),  'auth'),
    'learning'        : r => require.ensure([], () => r(require('./components/learning_login')),   'auth'),
    'learningdashboard'        : r => require.ensure([], () => r(require('../././education/main'))),
    'learningreport'        : r => require.ensure([], () => r(require('../././education/report'))),
    'registered'     : r => require.ensure([], () => r(require('./components/registered'))),
    'logout'     : r => require.ensure([], () => r(require('./components/logout'))),
    'userportalLogin'        : r => require.ensure([], () => r(require('./components/userportal')),   'auth'),
    'bekaertUserportalLogin'        : r => require.ensure([], () => r(require('./components/bekaertUserportalLogin')),   'auth'),
    'lmsSso'     : r => require.ensure([], () => r(require('./components/lmsSso')),   'auth'),
}

const ForgetPassword = r => require.ensure([], () => r(require('./components/forgotPassword')), 'auth-forget-password')
const PrivacyPolicy = r => require.ensure([], () => r(require('./components/privacyPolicy')), 'auth-privacy-policy')
const termsAndConditions = r => require.ensure([], () => r(require('./components/termsAndConditions')), 'auth-terms-policy')

export default [
    // {
    //     name: 'ssologin.login',
    //     path: '/ssologin',
    //     component: Auth.ssologin,
    //     meta: { requiresAuth: false },
    // },
    {
        name: 'auth.login',
        path: '/login',
        component: Auth.login,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.register',
        path: '/register',
        component: Auth.register,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.saml',
        path: '/saml',
        component: Auth.saml,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.registered',
        path: '/registered',
        component: Auth.registered,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.learning',
        path: '/learning/login/:id',
        component: Auth.learning,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.learningdashboard',
        path: '/learning/dashboard/:id',
        component: Auth.learningdashboard,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.learningreport',
        path: '/learning/reports/:id',
        component: Auth.learningreport,
        meta: { requiresAuth: false },
    },

    {
        name: 'auth.verification',
        path: '/verification',
        component: Auth.verification,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.reset',
        path: '/reset',
        component: ForgetPassword,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.privacypolicy',
        path: '/privacypolicy',
        component: PrivacyPolicy,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.termsAndConditions',
        path: '/TermsAndConditions',
        component: termsAndConditions,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.licenceexpire',
        path: '/licenceexpire',
        component: Auth.licenceexpire,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.registered',
        path: '/registered',
        component: Auth.registered,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.logout',
        path: '/logout',
        component: Auth.logout
    },
    {
        name: 'auth.userportalLogin',
        path: '/userportal/login',
        component: Auth.userportalLogin,
        meta: { requiresAuth: false },
    },
    {
        name: 'auth.bekaertUserportalLogin',
        path: '/bekaert/userportal/login',
        component: Auth.bekaertUserportalLogin,
        meta: { requiresAuth: false },
    },
    {
        // LMS SSO bridge for cross-subdomain deep-links (e.g. LMS approval email).
        // Public route: the component decides auth (hand off if logged in, else
        // stash the intended path and route to the ADMIN login).
        name: 'auth.lmsSso',
        path: '/lms-sso',
        component: Auth.lmsSso,
        meta: { requiresAuth: false },
    },
]



// WEBPACK FOOTER //
// ./src/app/auth/routes.js